export const UME_SERVICE = {
  MY_POLICY_FILES: '__SERVICE_MY_POLICY_FILES',
  MY_QUESTIONNAIRE: '__SERVICE_MY_QUESTIONNAIRE',
  MY_KYC: '__SERVICE_MY_KYC',
  MY_PUBLIC_PROFILE: '__SERVICE_MY_PUBLIC_PROFILE',
  MUTUAL_DUE_DILIGENCE: '__SERVICE_MUTUAL_DUE_DILIGENCE',
  PROVIDER: '__SERVICE_PROVIDER',
  MANAGED_NETWORK: '__SERVICE_MANAGED_NETWORK',
  MANAGED_SERVICE: '__MANAGED_SERVICE',
  SERVICE_WORK_ORDER: '__SERVICE_WORK_ORDER',
  MY_POLICY_FILE: '__SERVICE_MY_POLICY_FILES',
  PUBLIC_KPI: '__SERVICE_PUBLIC_KPI',
  PRIVATE_KPI: '__SERVICE_PRIVATE_KPI',
  FUND_DISTRIBUTORS_OVERSIGHT: '__FUND_DISTRIBUTORS_OVERSIGHT', // premium
  OVERSIGHT_FOLLOWUP: '__SERVICE_OVERSIGHT_FOLLOWUP',
  MANAGED_FOLLOWUP: '__SERVICE_MANAGED_FOLLOWUP',
  OVERSIGHT_ASSESSMENT: '__SERVICE_OVERSIGHT_ASSESSMENT',
  MODULAR_ASSESSMENT: '__SERVICE_MODULAR_ASSESSMENT',
  MANAGED_NETWORK_PARTICIPANT: '__SERVICE_MANAGED_NETWORK_PARTICIPANT',
  SERVICE_MANAGED_ASSESSMENT: '__SERVICE_MANAGED_ASSESSMENT', // For sub-accounts
  SERVICE_PREMIUM_ACCOUNT: '__SERVICE_PREMIUM_ACCOUNT', // VP service
  UNLIMITED_OVERSIGHT: '__SERVICE_UNLIMITED_OVERSIGHT',
  SERVICE_MANAGED_NETWORK_IM: '__SERVICE_MANAGED_NETWORK_IM',
  SERVICE_CUSTOM_LABEL: '__SERVICE_CUSTOM_LABEL',
  SERVICE_MANAGED_LABELS: '__SERVICE_MANAGED_LABELS',
  SERVICE_SCREENING: '__SERVICE_SCREENING',
  SERVICE_SCREENING_PREVIEW: '__SERVICE_SCREENING_SIZING_PREVIEW',
  SERVICE_ONBOARDING_SUPPORT: '__SERVICE_ONBOARDING_SUPPORT',
  SERVICE_ONBOARDING: '__SERVICE_ONBOARDING',
  SERVICE_FILES: '__SERVICE_COUNTERPARTY_PREMIUM_FILES',
  SERVICE_KYC: '__SERVICE_COUNTERPARTY_PREMIUM_KYC',
  SERVICE_INVESTMENT_PRODUCTS: '__SERVICE_INVESTMENT_PRODUCTS',
  SERVICE_NETWORK_ALLOCATION: '__SERVICE_NETWORK_ALLOCATION',
  SERVICE_REPORTING: '__SERVICE_REPORTING',
  SERVICE_API: '__SERVICE_API',
  SERVICE_MANAGED_NETWORK_REPORTING: '__SERVICE_MANAGED_NETWORK_REPORTING',
  SERVICE_AI_DOCUMENT_ANALYSIS: '__SERVICE_AI_DOCUMENT_ANALYSIS',
  SERVICE_INTERACTIVE_AI: '__SERVICE_INTERACTIVE_AI',
  SERVICE_MANAGE_SUBSCRIPTIONS: '__SERVICE_MANAGE_SUBSCRIPTIONS',
  CONDITIONAL_CHECKLIST: '__SERVICE_CONDITIONAL_CHECKLIST',
} as const;

export type UmeService = (typeof UME_SERVICE)[keyof typeof UME_SERVICE];
